import { styled } from '@mui/material/styles';
import { Box, Typography, IconButton, Fab, Button, TextField, Paper, Chip } from '@mui/material';

// Common Fab styles
export const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1200,
  backgroundColor: '#2a2a2a',
  '&:hover': { backgroundColor: '#3a3a3a' },
  borderRadius: '50%',
}));

// Common search field
export const SearchField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.5),
    '& fieldset': { 
      borderColor: 'rgba(255, 255, 255, 0.23)',
      borderRadius: theme.spacing(2)
    },
    '&:hover fieldset': { 
      borderColor: 'rgba(255, 255, 255, 0.4)' 
    },
    '&.Mui-focused fieldset': { 
      borderColor: 'rgba(255, 255, 255, 0.6)' 
    },
  },
  '& .MuiInputBase-input': {
    '&::placeholder': {
      color: 'rgba(255, 255, 255, 0.6)',
      opacity: 1
    }
  }
}));

// Common action button
export const ActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.4),
  fontWeight: 'bold',
  fontSize: '0.9rem',
  borderRadius: theme.spacing(2),
  textTransform: 'none',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
  }
}));
// Flash deal button variant with different gradient
export const FlashDealButton = styled(Button)(({ theme }) => ({
  py: 1.2,
  fontSize: '0.9rem',
  fontWeight: 600,
  borderRadius: 8,
  background: 'linear-gradient(135deg, #464545 0%, #333333 100%)',
  color: 'white',
  textTransform: 'none',
  border:'none'
}));
export const CreateTripButton = styled(Button)(({ theme }) => ({
  py: 1.2,
  fontSize: '0.9rem',
  fontWeight: 600,
  borderRadius: 8,
  background: 'linear-gradient(135deg, #464545 0%, #333333 100%)',
  color: 'white',
  textTransform: 'none',
  border:'none'
}));
// Primary action button
export const PrimaryActionButton = styled(ActionButton)(({ theme }) => ({
  boxShadow: '0 4px 8px rgba(25, 118, 210, 0.25)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 12px rgba(25, 118, 210, 0.35)',
  }
}));

// Secondary action button  
export const SecondaryActionButton = styled(ActionButton)(({ theme }) => ({
  boxShadow: '0 4px 8px rgba(156, 39, 176, 0.25)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 12px rgba(156, 39, 176, 0.35)',
  }
}));

// Custom colored button
export const CustomColorButton = styled(ActionButton)<{ customColor: string }>(({ theme, customColor }) => ({
  backgroundColor: customColor,
  color: 'white',
  boxShadow: `0 4px 8px ${customColor}40`,
  '&:hover': {
    backgroundColor: customColor,
    filter: 'brightness(0.9)',
    transform: 'translateY(-2px)',
    boxShadow: `0 6px 12px ${customColor}55`,
  }
}));

// Form field container
export const FormFieldContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#252526',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
}));

// Status chip
export const StatusChip = styled(Chip)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
}));

// Icon container
export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1),
}));

// Loading container
export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
  padding: theme.spacing(4),
}));

// Error container
export const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
}));
